import React from 'react';

import messages from './messages';
import SearchBar from './search/SearchBar';

function getWelcomeText(lang) {
  switch (lang) {
    case 'en':
      return (
        <div>
          <p><b>Welcome to the renewed interface of the STADAT spreadsheet set!</b></p>
          <p>From April 6, 2021, users can access <b>more contents and new functions in a changed structure</b> at the (STADAT) tables summarizing the most important statistical data and indicators. Our <b>mobile-optimized, accessible spreadsheet system</b> has been expanded with a number of convenience features. To help users of the old STADAT tables to navigate in the new system, HCSO provides hyperlinks from the <a href="/engstadat_archive" target="_blank">old tables</a> to the new ones and a <a href="/stadat_files/features.pdf">guide</a> to the changes.</p>
          <p><br /></p>
          <p>The <b>comprehensive collection of completed tables</b> (STADAT) contains main statistical data, indices, collected by the HCSO or received from other organisations, characteristically in time series format. Following the selection of categories <b>one may research the tables, furthermore may choose from below filtering options:</b></p>
          <ul>
            <li>periods (yearly and infra- annual)</li>
            <li>territorial levels (national, regional, international)</li>
            <li>content (active, archive)</li>
          </ul>
          <p>We publish our <b>territorial</b> data by county and region, occasionally by settlement type. The main <b>international</b> indicators may be accessed in regard to the European Union member states as well certain other countries.</p>
          <p>Other functions, information may be accessed by opening the right side <b>menu</b> of the tables:</p>
          <ul>
            <li>one may return to the <b>list of tables of the chosen category</b></li>
            <li>the <b>XLSX and CSV files</b>, suitable for further processing of the table may be downloaded</li>
            <li>you can find the legend (e.g. what does the colouring of the numbers mean),</li>
            <li><b>methodological information</b> regarding data interpretation is available</li>
            <li><b>other publications about the subject matter</b> may be downloaded (tables, Dissemination database datasets, publications)</li>
          </ul>
          <p>We kindly request our customers to click the „<b>Was the content useful?</b>” button and evaluate the usefulness and interpretability of the data and make suggestions. Help us to help you!</p>
        </div>
      );
    default:
      return (
        <div>
          <p><b>Üdvözöljük a STADAT-táblakészlet megújult felületén!</b></p>
          <p>2021. április 6-tól a felhasználók <b>bővebb tartalommal, megváltozott szerkezettel és új funkciókkal</b> érhetik el a legfontosabb statisztikai adatokat, mutatókat összefoglaló (STADAT) tábláinkat. A <b>mobilra optimalizált, akadálymentesített táblarendszer</b> számos kényelmi szolgáltatással bővült. A KSH a <a href="/stadat_archive" target="_blank">régi STADAT-táblákat</a> használók eligazodását az új rendszerben a régi tábláknál az újakra történő hivatkozással támogatja, illetve egy, a változásokat ismertető <a href="/stadat_files/ujdonsagok.pdf">segédlettel</a> szolgálja.</p>
          <p><br /></p>
          <p>A <b>kész táblákat tartalmazó összefoglaló táblagyűjtemény</b> (STADAT) a KSH által gyűjtött, illetve más szervezetektől átvett főbb statisztikai adatokat, mutatókat tartalmazza, jellemzően <b>idősorosan</b>.</p>
          <p>Az egyes témakörök kiválasztása után a <b>táblákban lehet keresni, továbbá az alábbi szűrési lehetőségek közül lehet választani:</b></p>
          <ul>
            <li>időszakok (éves és évközi),</li>
            <li>területi szintek (országos, területi, nemzetközi),</li>
            <li>valamint tartalom (aktív, archív) szerinti szűrés.</li>
          </ul>
          <p><b>Területi</b> adatainkat megye és régió, esetenként településtípus szerint közöljük. A főbb <b>nemzetközi</b> mutatók az Európai Unió tagországaira, illetve néhány további országra vonatkozóan érhetők el.</p>
          <p>A tábláknál található jobb oldali <b>menü</b> megnyitásával további funkciók, információk érhetők el:</p>
          <ul>
            <li>visszatérhetünk a kiválasztott <b>témakör táblajegyzékéhez</b>,</li>
            <li>letölthetők a tábla további feldolgozására alkalmas <b>XLSX és CSV</b> fájlok,</li>
            <li>megtalálható a jelmagyarázat (pl. számok színezése mit jelent),</li>
            <li>elérhetők az adatok értelmezéséhez szükséges <b>módszertani információk</b>,</li>
            <li>letölthetők a témához <b>kapcsolódó további publikációk</b> (táblák, Tájékoztatási adatbázis adatkörei, kiadványok).</li>
          </ul>
          <p>Kérjük, hogy a táblák megtekintése után kattintson az oldal alján lévő „<b>Hasznos volt ez a tartalom?</b>” gombra és <b>értékelje az adatok hasznosságát, értelmezhetőségét, tegyen javaslatot</b>! Segítsen, hogy segíthessünk!</p>
        </div>
      );
  }
}

export default function ({ lang }) {
  const trans = messages[lang];

  return (
    <React.Fragment>
      <h1 id="content-title">{trans.welcomeTitle}</h1>
      <SearchBar {...{ lang }} />
      {getWelcomeText(lang)}
    </React.Fragment>
  );
};
